// extracted by mini-css-extract-plugin
export default {"Steps":"style_Steps__cG+Ic","step":"style_step__k8Vw3","active":"style_active__mp-wP"};